import coloredLogosBR from './colored-logos';
import grayLogosBR from './gray-logos';
import whiteLogosBR from './white-logos';

const LogosBR = {
    colored: coloredLogosBR,
    gray: grayLogosBR,
    white: whiteLogosBR
};

export default LogosBR;
